import { Badge } from "@/components/ui/badge";
import { getPageVersion, type PageVersion } from "@/utils/pageVersions";

interface RevisionBadgeProps {
  pageKey: string;
  className?: string;
  showDescription?: boolean;
}

const RevisionBadge = ({ pageKey, className, showDescription = false }: RevisionBadgeProps) => {
  const versionInfo: PageVersion = getPageVersion(pageKey);
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Badge 
        variant="outline" 
        className="text-xs font-mono bg-muted/50 text-muted-foreground border-muted-foreground/20"
        title={`Last modified: ${versionInfo.lastModified}${versionInfo.description ? ` - ${versionInfo.description}` : ''}`}
      >
        v{versionInfo.version}
      </Badge>
      {showDescription && versionInfo.description && (
        <span className="text-xs text-muted-foreground">
          {versionInfo.description}
        </span>
      )}
    </div>
  );
};

export default RevisionBadge;